import { faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Row } from "react-bootstrap";
import { CompPagFrete, infPagInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { useEffect, useRef, useState } from "react";
import { formatMoeda, getUuidV4, goToFocus, strToFloat } from "../../../utils/utils";
import { ButtonRemover, ButtonTrash, JTable, JTBody, JTHead } from "../../../components/Components";
import { TypeComponente } from "../../../lists";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";

const initialForm: CompPagFrete = {
    id: 0,
    tpComp: '01',
    vComp: 0,
    xComp: ''
}

interface formProps {
    form: infPagInterface;
    setForm: React.Dispatch<React.SetStateAction<infPagInterface>>
}

const Componente: React.FC<formProps> = ({ form, setForm }) => {
    const [selecionado, setSelecionado] = useState<number | string>('');
    const [component, setComponent] = useState<CompPagFrete>(initialForm);
    const [saldo, setSaldo] = useState<number>(form.vContrato);
    const vCompRef = useRef<HTMLInputElement>(null);
    const vDescRef = useRef<HTMLInputElement>(null);
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setComponent((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleChangeNumeric = (e: any) => {
        const { name, value } = e.target;

        setComponent((prev) => ({
            ...prev,
            [name]: strToFloat(value)
        }))
    }

    const validarPreenchimento = () => {

        if (component.vComp === 0) {
            goToFocus(vCompRef)
            alertModal('Informe o Vlr. do componente.');
            return false;
        }

        if (component.tpComp === '99') {
            if (component.xComp.trim() === "") {
                goToFocus(vDescRef);
                alertModal('Informe a descrição do tipo Outro.');
                return false;
            }
        }

        if (saldo === 0) {
            goToFocus(vCompRef)
            alertModal('A somatoria dos componentes atingiu o valor do contrato');
            return false;
        }

        if (component.vComp > saldo) {
            goToFocus(vCompRef)
            alertModal('Vlr. do componente maior que o saldo restante. Informe o valor menor ou igual ao saldo.');
            return false;
        }

        return true
    }

    const handleAddComponent = () => {
        if (validarPreenchimento()) {
            setForm({
                ...form,
                comp: [...(form.comp || []), {
                    id: getUuidV4(),
                    tpComp: component.tpComp,
                    vComp: component.vComp,
                    xComp: component.xComp
                }]
            });
            setComponent(initialForm);
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id)
        const confirmed = await confirm({
            message: <>Deseja realmente remover <strong>{TypeComponente.find(item => item.id === value.title)?.name}</strong> ?</>,
            title: "Confirmação",
        })

        if (confirmed) {
            setForm({
                ...form,
                comp: form.comp?.filter((item: CompPagFrete) => item.id !== value.id)
            })
        }
        setSelecionado('')
    }

    const removerTudo = async () => {
        if (form.comp && form.comp.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todos ?</>,
                title: "Confirmação",
            })
            if (confirmed) {
                setForm({
                    ...form,
                    comp: []
                })
            }
        }
    }

    useEffect(() => {
        const total = form.comp?.map((item: CompPagFrete) => item.vComp)
            .reduce((total, num) => total + num, 0) || 0;
        setSaldo(form.vContrato - total);

    }, [form.vContrato, form.comp])

    return (<>
        <Row className="mb-3 g-2">
            <Col md={4}>
                <Form.Group controlId="tpComp">
                    <Form.Label>Tipo Componente</Form.Label>
                    <Form.Select name="tpComp" value={component.tpComp} onChange={(e) => {
                        setComponent({
                            ...component,
                            tpComp: e.target.value,
                            xComp: e.target.value != '99' ? '' : component.xComp
                        })
                    }}>
                        {TypeComponente.map(x => (
                            <option key={x.id} value={x.id}>{x.name}</option>
                        ))}

                    </Form.Select>
                </Form.Group>
            </Col>
            <Col md={3}>
                <Form.Group controlId="vComp">
                    <Form.Label>Vlr Componente</Form.Label>
                    <Form.Control type="number" name="vComp" value={component.vComp} maxLength={16}
                        ref={vCompRef}
                        onChange={handleChangeNumeric}
                    />
                </Form.Group>
            </Col>

            {component.tpComp === '99' && (
                <Col md>
                    <Form.Group>
                        <Form.Label>Descrição do componente</Form.Label>
                        <Form.Control maxLength={60} name="xComp" value={component.xComp}
                            ref={vDescRef}
                            onChange={handleChange} />
                    </Form.Group>
                </Col>
            )}

        </Row>
        <Row className="mb-3 g-2">

            <Col md={'auto'} className="d-flex align-items-end">
                <Button title="Adicionar componente" onClick={handleAddComponent}>
                    <FontAwesomeIcon icon={faPlus} /> Adicionar
                </Button>
            </Col>

            <Col md={'auto'} className="d-flex align-items-center mb-0">
                <Form.Label className="mb-0">Saldo Vlr Contrato</Form.Label>
            </Col>

            <Col md='4'>
                <Form.Control value={formatMoeda(saldo)} disabled />
            </Col>

        </Row>

        <JTable>
            <JTHead>
                <tr>
                    <th className="text-center" style={{ width: '2.5rem' }}>
                        <ButtonTrash onClick={() => removerTudo()} icon={faTrashAlt} />
                    </th>
                    <th>Tipo Componente</th>
                    <th>Valor do componente</th>
                    <th>Descrição Outros</th>
                </tr>
            </JTHead>
            <JTBody>
                {form.comp?.map((item: CompPagFrete) => (
                    <tr key={item.id} className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                        <td className="text-center">
                            <ButtonRemover
                                onClick={() => handleRemover({ id: item.id.toString(), title: item.tpComp })}
                            />
                        </td>
                        <td>{TypeComponente.find(comp => comp.id === item.tpComp)?.name}</td>
                        <td>{formatMoeda(item.vComp ?? 0)}
                        </td>
                        <td>{item.xComp}</td>
                    </tr>
                ))}
            </JTBody>
        </JTable>
        {ConfirmModal}
        {ModalMessageEl}
    </>)
}

export default Componente;
